import FormModel from './formModel';

const {
    formField: {
        name,
        lastName,
        email,
        phone,
        postCode,
        dni,
        carProdSelected,
        comments,
    }
} = FormModel;


export default {
    [name.name]: '',
    [lastName.name]: '',
    [email.name]: '',
    [phone.name]: '',
    [dni.name]: '',
    [postCode.name]: '',
    [carProdSelected.name]: "3",
    [comments.name]: '',
    archivos: [],
    vehiculo: {
        marca: '',
        anio: '',
        modelo: '',
        version: '',
        patente: '',
        tieneGnc: '0',
        valorGnc: 700000,
        adtValue: 0,
    }
};
